import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';

import { PersistentInviteEligibleQuery } from './PersistentInviteEligibleQuery.graphql.ts';
import type {
	PersistentInviteEligibleQuery as PersistentInviteEligibleQueryType,
	PersistentInviteEligibleQueryVariables,
} from './__types__/PersistentInviteEligibleQuery.ts';

export async function preloadPersistentInviteButtonEligible(
	{ spaceKey }: { spaceKey?: string },
	skipSpaceQuery: boolean = false,
) {
	const { edition, isLicensed, userId } = getPreloaderFnContext();

	const isFreeEdition = edition === ConfluenceEdition.FREE;

	return query<PersistentInviteEligibleQueryType, PersistentInviteEligibleQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: PersistentInviteEligibleQuery,
		variables: {
			spaceKey,
			skipLicenseQuery: isFreeEdition || !isLicensed || !Boolean(userId) || skipSpaceQuery,
			skipSpaceQuery: !Boolean(spaceKey),
		},
	});
}
